import React, { useState, useEffect } from "react";
import ModalEditarAluno from "./ModalEditarAluno";
import "./ModalDetalhes.css";

const formatarData = (dataIso, incluirHora = false) => {
  if (!dataIso) return "Não informada";
  const data = new Date(dataIso);
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const ano = data.getFullYear();
  const hora = String(data.getHours()).padStart(2, '0');
  const minutos = String(data.getMinutes()).padStart(2, '0');

  return incluirHora
    ? `${dia}/${mes}/${ano} ${hora}:${minutos}`
    : `${dia}/${mes}/${ano}`;
};

const calcularIdade = (dataNascimento) => {
  if (!dataNascimento) return "Desconhecida";
  const hoje = new Date();
  const nascimento = new Date(dataNascimento);
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  const m = hoje.getMonth() - nascimento.getMonth();
  if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
    idade--;
  }
  return idade;
};

const ModalDetalhes = ({ aluno, onClose, onAtualizarLista }) => {
  const [mostrarEditar, setMostrarEditar] = useState(false);

  useEffect(() => {
    console.log("🟩 ModalDetalhes montado com aluno:", aluno);
  }, [aluno]);

  if (!aluno) return null;

  const handleAtualizar = () => {
    if (typeof onAtualizarLista === "function") {
      onAtualizarLista();
    }
    setMostrarEditar(false);
  };

  return (
    <div className="modal">
      <div className="modal-detalhes-content">
        <h3>Detalhes do aluno Ativo</h3>

        <div className="detalhes-grid">
          <p><strong>Nome:</strong> {aluno.nome_completo}</p>
          <p><strong>Gênero:</strong> {aluno.genero}</p>
          <p>
            <strong>Data de Nascimento:</strong>{" "}
            {formatarData(aluno.data_nascimento)} ({calcularIdade(aluno.data_nascimento)} anos)
          </p>
          <p><strong>Nacionalidade:</strong> {aluno.nacionalidade || "Não informada"}</p>
          <p><strong>Naturalidade:</strong> {aluno.naturalidade || "Não informada"}</p>
          <p><strong>Tipo de Documento:</strong> {aluno.tipo_documento || "Não informado"}</p>
          <p><strong>Número do Documento:</strong> {aluno.numero_documento || "Não informado"}</p>
          <p><strong>Turma:</strong> {["A","B","C","D"].includes(aluno.turma) ? aluno.turma : "Não atribuída"}</p>
          <p><strong>Classe:</strong> {aluno.classe}</p>
          <p><strong>Email:</strong> {aluno.email || "Não informado"}</p>
          <p><strong>Telefone do Responsável:</strong> {aluno.telefone_responsavel}</p>
          <p><strong>Histórico Médico:</strong> {aluno.historico_medico || "Nenhum"}</p>
          <p><strong>Nome do Pai:</strong> {aluno.nome_pai}</p>
          <p><strong>Telefone do Pai:</strong> {aluno.telefone_pai}</p>
          <p><strong>Nome da Mãe:</strong> {aluno.nome_mae}</p>
          <p><strong>Telefone da Mãe:</strong> {aluno.telefone_mae}</p>
          <p><strong>Deficiência:</strong> {aluno.deficiencia || "Nenhuma"}</p>
          <p><strong>Doença Crônica:</strong> {aluno.doenca_cronica || "Nenhuma"}</p>
          <p><strong>Outras Condições:</strong> {aluno.outras_condicoes || "Nenhuma"}</p>
          <p><strong>Data da Matrícula:</strong> {formatarData(aluno.data_matricula, true)}</p>
          <p><strong>Código do Aluno:</strong> {aluno.codigo_aluno || "Não informado"}</p>
          <p><strong>Valor da Matrícula:</strong>{" "}
            {aluno.valor_matricula && aluno.valor_matricula !== 0
              ? Number(aluno.valor_matricula).toLocaleString("pt-PT", {
                  style: "currency",
                  currency: "MZN",
                  minimumFractionDigits: 2,
                })
              : "Não informado"}
          </p>
          <p><strong>Serviço:</strong> Matrícula</p>
          <p><strong>Referência:</strong> {
            aluno.pagamentos?.[0]?.referencia ||
            aluno.Pagamentos?.[0]?.referencia ||
            aluno.pagamento?.referencia ||
            aluno.referencia_pagamento ||
            "Não gerada ainda"
          }</p>
        </div>

        <div className="botoes-modal">
          <button
            className="btn-editar"
            onClick={() => setMostrarEditar(true)}
          >
            Editar
          </button>
          <button className="btn-fechar" onClick={onClose}>Fechar</button>
        </div>
      </div>

      {mostrarEditar && (
        <ModalEditarAluno
          aluno={aluno}
          onClose={() => setMostrarEditar(false)}
          onAtualizar={handleAtualizar}
        />
      )}
    </div>
  );
};

export default ModalDetalhes;
